"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const Checkbox = ({ checked, onChange, label, variant = "checkbox", labelPosition = "end" }) => {
    const id = react_1.default.useMemo(() => Math.random().toString(36).substr(2, 9), []);
    return ((0, jsx_runtime_1.jsxs)("div", { className: `${labelPosition === "end" ? "form-check" : "form-check-reverse"} ${variant === "switch" ? "form-switch" : ""}`, children: [(0, jsx_runtime_1.jsx)("label", { className: "form-check-label", htmlFor: id, style: {
                    userSelect: "none",
                }, children: label }), (0, jsx_runtime_1.jsx)("input", { className: "form-check-input", type: "checkbox", role: variant, id: id, checked: checked, onChange: (active) => {
                    onChange === null || onChange === void 0 ? void 0 : onChange(active.target.checked);
                } })] }));
};
exports.Checkbox = Checkbox;
